module.exports = __webpack_public_path__ + "static/media/s4.40a08170.png";